import React from "react";
import { useSelector } from "react-redux";
import { QUILL_EMPTY_STRING, TERMS_AND_CONDITIONS, PRIVACY_POLICY } from "../../../../../../isomorphic/constants";
import get from "lodash/get";
import "./agreement-text.module.css";

export const AgreementText = ({ currentScreen, customAgreementText }) => {
  const { enableLocalization = false, localizedElements = {} } = useSelector((state) =>
    get(state, ["qt", "config", "pagebuilder-config", "general", "localization"], {})
  );
  const sketchesHost = useSelector((state) => get(state, ["qt", "config", "sketches-host"]));
  const localizedElementsData = enableLocalization ? localizedElements : {};
  const { termsConditions: customTermsAndCondition, privacyPolicy: customPrivacyPolicy } = get(
    localizedElementsData,
    ["signInSignUp"],
    {}
  );

  const terms = `<a class="auth--text-color" href="${sketchesHost}/terms-and-conditions" target="_blank" rel="noopener noreferrer">${
    customTermsAndCondition || TERMS_AND_CONDITIONS
  }</a>`;

  const privacy = `<a class="auth--text-color" href="${sketchesHost}/privacy-policy" target="_blank" rel="noopener noreferrer">${
    customPrivacyPolicy || PRIVACY_POLICY
  }</a>`;

  if (customAgreementText && customAgreementText !== QUILL_EMPTY_STRING) {
    const shortCodeMapping = [
      { code: "[terms-and-conditions]", value: terms },
      { code: "[privacy-policy]", value: privacy },
    ];

    shortCodeMapping.forEach((item) => {
      customAgreementText = customAgreementText.replace(item.code, item.value);
    });
    return <div styleName="terms-privacy" dangerouslySetInnerHTML={{ __html: customAgreementText }} />;
  }

  const defaultAgreementText =
    currentScreen === "otp"
      ? `By proceeding, you agree to the ${terms} and ${privacy}`
      : `By signing up, you agree to the ${terms} and ${privacy}`;

  return <div styleName="terms-privacy" dangerouslySetInnerHTML={{ __html: defaultAgreementText }} />;
};
